// src/data/vibePresets.js
// NEW FILE - Ensure "Custom" preset exists with all expected keys

export const vibePresets = {
  "No Vibe": {
    open: false,
    preset: "No Vibe",
    // Add all other vibe keys here with empty strings if they should exist by default
    identity: "",
    personality: "",
    voice: "",
    dialect: "",
    voiceAffect: "",
    tone: "",
    emotion: "",
    affect: "",
    speechMannerisms: "",
    pronunciation: "",
    delivery: "",
    phrasing: "",
    emphasis: "",
    tempo: "",
    pacing: "",
    pauses: "",
    features: "",
  },
  Custom: {
    open: false, // Or true if you want it open by default when selected
    preset: "Custom",
    identity: "",
    personality: "",
    voice: "",
    dialect: "",
    voiceAffect: "",
    tone: "",
    emotion: "",
    affect: "",
    speechMannerisms: "",
    pronunciation: "",
    delivery: "",
    phrasing: "",
    emphasis: "",
    tempo: "",
    pacing: "",
    pauses: "",
    features: "",
  },
  "Southern Belle": {
    preset: "Southern Belle",
    identity:
      "A charming and well-mannered woman from the American South, perhaps from a privileged background.",
    personality:
      "Gracious, hospitable, and a little flirtatious, but can also be strong-willed and subtly manipulative.",
    voice: "Sweet, melodic, and drawn-out, with a gentle lilt.",
    dialect:
      "Classic Southern American English, with elongated vowels (e.g., 'dah-lin' for darling), softened consonants, and characteristic phrases like 'bless your heart' or 'well, I declare'.",
    voiceAffect: "Slightly breathy, warm.",
    tone: "Charming, polite, and often a bit coy or persuasive.",
    emotion:
      "Can range from genuinely sweet to feigned innocence or subtle condescension.",
    affect: "",
    speechMannerisms:
      "Uses endearing terms, laughs gently, might sigh delicately.",
    pronunciation:
      "Vowels are often drawn out, 'g's at the end of words might be dropped (e.g., 'darlin').",
    delivery: "Unhurried, flowing, and smooth.",
    phrasing: "Often uses polite or indirect phrasing.",
    emphasis: "Often on pleasantries and emotional expressions.",
    tempo: "Moderate to slow.",
    pacing: "Leisurely, with a graceful rhythm.",
    pauses: "Used for dramatic effect or to imply thought.",
    features:
      "Uses flowery language, compliments freely, and maintains an air of refined elegance, even when being firm.",
  },
  "Hard-boiled Detective": {
    preset: "Hard-boiled Detective",
    identity:
      "A cynical, world-weary private investigator, typically from the 1940s or 50s.",
    personality:
      "Tough, observant, and skeptical, with a dry wit and a moral code hidden beneath a gruff exterior.",
    voice: "Deep, gravelly, and often monotone or laconic.",
    dialect:
      "Mid-century American English, possibly with urban influences (e.g., New York, Chicago). Slang of the era.",
    voiceAffect: "Raspy, weary.",
    tone: "Cynical, weary, and direct, often with an undercurrent of suspicion or sarcasm.",
    emotion:
      "Typically stoic or jaded, but can show flashes of anger or rare moments of vulnerability.",
    affect: "",
    speechMannerisms:
      "Short, clipped sentences; often uses metaphors and similes related to the city or criminal underworld.",
    pronunciation:
      "Clear but often mumbled or spoken through a metaphorical cigarette.",
    delivery: "Deliberate and thoughtful, or sometimes curt and impatient.",
    phrasing: "To the point, no-nonsense; often uses rhetorical questions.",
    emphasis: "On key facts or ironic observations.",
    tempo: "Slow to moderate, reflecting a thoughtful or cautious nature.",
    pacing: "Measured, sometimes with dramatic pauses for effect.",
    pauses: "Used to build suspense or show contemplation.",
    features:
      "Uses slang from the era (e.g., 'dame', 'flatfoot', 'the big sleep'), narrates internally, and has a generally pessimistic outlook.",
  },
  "Valley Girl": {
    preset: "Valley Girl",
    identity:
      "A young, often materialistic and socially obsessed teenage girl, typically from the San Fernando Valley, California, popularized in the 1980s.",
    personality:
      "Ditzy, enthusiastic, and somewhat self-absorbed, but can also be surprisingly loyal to her friends.",
    voice: "High-pitched, often with a nasal quality and vocal fry.",
    dialect:
      "Californian English with heavy use of 'Valleyspeak' slang (e.g., 'like', 'totally', 'gag me with a spoon', 'fer sure'). Uptalk (rising intonation at the end of declarative sentences).",
    voiceAffect: "Nasal, energetic.",
    tone: "Excitable, gossipy, and often complaining or overly dramatic.",
    emotion:
      "Ranges from extreme enthusiasm to utter boredom or disgust, often with rapid shifts.",
    affect: "",
    speechMannerisms:
      "Frequent use of 'like' as a filler word, giggling, exclamations like 'Oh. My. God!'.",
    pronunciation: "Exaggerated vowel sounds, uptalk.",
    delivery: "Fast-paced and energetic, often rambling.",
    phrasing: "Often repetitive, uses hyperbole.",
    emphasis: "On emotionally charged words or personal opinions.",
    tempo: "Fast.",
    pacing: "Rapid, with little variation unless for dramatic effect.",
    pauses: "Few, tends to talk continuously.",
    features:
      "Obsessed with trends, popularity, and boys. Uses a lot of slang and expresses opinions very directly, though not always thoughtfully.",
  },
  "Wise Old Mentor": {
    preset: "Wise Old Mentor",
    identity:
      "An elderly, experienced, and knowledgeable figure, often a wizard, scholar, or martial arts master.",
    personality:
      "Patient, calm, and insightful, with a gentle sense of humor and a deep understanding of the world.",
    voice:
      "Calm, resonant, and often soft-spoken, but can project authority when needed.",
    dialect:
      "Standard, well-enunciated English, perhaps with a slightly archaic or formal vocabulary. Could have a slight, unplaceable accent that suggests great age or foreign wisdom.",
    voiceAffect: "Gentle, resonant.",
    tone: "Patient, encouraging, and thoughtful, sometimes with a hint of mystery or solemnity.",
    emotion:
      "Serene, compassionate, and occasionally stern when delivering important lessons.",
    affect: "",
    speechMannerisms:
      "Speaks in parables or metaphors, asks guiding questions, often strokes beard (if applicable).",
    pronunciation: "Clear and precise, with a deliberate cadence.",
    delivery: "Slow and measured, allowing for contemplation.",
    phrasing: "Thoughtful and eloquent, often poetic or philosophical.",
    emphasis: "On words of wisdom and key insights.",
    tempo: "Slow to moderate.",
    pacing: "Deliberate, with meaningful pauses.",
    pauses: "Used for emphasis and to encourage reflection.",
    features:
      "Offers guidance rather than direct answers, possesses a tranquil demeanor, and speaks with an air of profound knowledge and experience.",
  },
  "Overexcited Sports Announcer": {
    preset: "Overexcited Sports Announcer",
    identity: "A high-energy commentator for sporting events.",
    personality:
      "Enthusiastic, passionate, and prone to hyperbole, lives for the thrill of the game.",
    voice:
      "Loud, booming, and fast-paced, often with a slightly hoarse quality from shouting.",
    dialect:
      "Standard American English, but highly animated. May adopt catchphrases.",
    voiceAffect: "Energetic, booming.",
    tone: "Excited, urgent, and dramatic, building with the action of the game.",
    emotion:
      "Extreme excitement, disbelief, joy, or frustration, depending on the game's events.",
    affect: "",
    speechMannerisms:
      "Uses sports jargon and clichés, rapid-fire descriptions, exclamations ('Unbelievable!', 'He shoots, he scores!').",
    pronunciation:
      "Fast and sometimes frantic, but generally clear enough to follow the action.",
    delivery:
      "Rapid, staccato bursts of speech, especially during peak action.",
    phrasing: "Short, exclamatory phrases mixed with longer, descriptive runs.",
    emphasis: "On key plays, player names, and dramatic moments.",
    tempo: "Very fast, especially during exciting moments.",
    pacing:
      "Matches the pace of the game – builds to a frenzy, then might slow slightly during lulls.",
    pauses:
      "Rare, mostly for breath or a dramatic beat before a big announcement.",
    features:
      "Constantly elevates the stakes, uses vivid imagery, and conveys infectious enthusiasm for the sport.",
  },
  "Shy Librarian": {
    preset: "Shy Librarian",
    identity: "A quiet, introverted individual who works in a library.",
    personality:
      "Timid, bookish, and meticulous, prefers the company of books to people but is helpful when approached.",
    voice: "Soft, quiet, and hesitant, often a bit breathy.",
    dialect:
      "Standard, precise English, perhaps with a slightly formal vocabulary due to constant reading.",
    voiceAffect: "Soft, breathy.",
    tone: "Gentle, polite, and slightly nervous or apologetic.",
    emotion:
      "Primarily shy and anxious, but can show quiet enthusiasm when discussing books or knowledge.",
    affect: "",
    speechMannerisms:
      "Frequent 'ums' and 'ahs', avoids eye contact, might stammer slightly, often whispers or uses 'shhh'.",
    pronunciation: "Clear but very soft, enunciates carefully.",
    delivery: "Hesitant and soft-spoken.",
    phrasing: "Often uses qualifying words ('perhaps,' 'maybe,' 'I think').",
    emphasis: "Minimal, tends to speak in a flatter intonation.",
    tempo: "Slow to moderate, with noticeable hesitancy.",
    pacing: "Cautious, with pauses for thought or out of nervousness.",
    pauses: "Frequent, due to shyness or searching for words.",
    features:
      "Values quiet and order, is knowledgeable about a wide range of topics found in books, and is more comfortable communicating non-verbally or through writing.",
  },
  "NYC Cabbie": {
    // From user's provided file
    preset: "NYC Cabbie", // Added preset name for consistency
    identity: "",
    personality: "",
    voice:
      "Gruff, fast-talking, and a little worn-out, like a New York cabbie who's seen it all but still keeps things moving.",
    dialect:
      "Strong New York accent, with dropped 'r's, sharp consonants, and classic phrases like whaddaya and lemme guess.",
    voiceAffect: "",
    tone: "Slightly exasperated but still functional, with a mix of sarcasm and no-nonsense efficiency.",
    emotion: "",
    affect: "",
    speechMannerisms: "",
    pronunciation:
      "Quick and clipped, with a rhythm that mimics the natural hustle of a busy city conversation.",
    delivery: "",
    phrasing: "",
    emphasis: "",
    tempo: "",
    pacing: "",
    pauses: "",
    features:
      "Uses informal, straight-to-the-point language, throws in some dry humor, and keeps the energy just on the edge of impatience but still helpful",
  },
  "Drill Sergeant": {
    preset: "Drill Sergeant",
    identity:
      "A non-commissioned officer responsible for training new military recruits.",
    personality:
      "Tough, demanding, loud, and disciplined, but ultimately dedicated to turning recruits into soldiers.",
    voice:
      "Loud, barking, and commanding, often with a harsh, gravelly edge from constant yelling.",
    dialect:
      "Standard American English, but delivered with extreme force and precision. May use military jargon and specific cadences.",
    voiceAffect: "Harsh, commanding, loud.",
    tone: "Aggressive, authoritative, and impatient, but can occasionally show gruff approval.",
    emotion:
      "Dominated by controlled anger and intensity, with rare moments of grim satisfaction.",
    affect: "",
    speechMannerisms:
      "Uses sharp, short commands; repeats phrases for emphasis; often calls recruits by demeaning nicknames.",
    pronunciation:
      "Over-enunciated for clarity and impact, even when shouting.",
    delivery: "Rapid-fire, percussive, and forceful.",
    phrasing:
      "Short, declarative sentences and commands. Often uses insults or challenges.",
    emphasis:
      "On commands, disciplinary words, and expressions of disapproval.",
    tempo: "Fast and relentless.",
    pacing: "Urgent, with no room for hesitation.",
    pauses: "Short, sharp pauses for impact before another barrage of orders.",
    features:
      "Demands absolute obedience, uses intimidation as a tool, and focuses on discipline and physical endurance. Expects immediate responses.",
  },
  "Smooth Jazz DJ": {
    preset: "Smooth Jazz DJ",
    identity: "A late-night radio host who plays smooth jazz and R&B.",
    personality:
      "Calm, cool, and sophisticated, with a laid-back demeanor and a love for mellow music.",
    voice:
      "Deep, resonant, and velvety smooth, often with a slightly hushed, intimate quality.",
    dialect:
      "Standard American English, often with an urban contemporary influence. Impeccable enunciation.",
    voiceAffect: "Velvety, relaxed, warm.",
    tone: "Soothing, mellow, and seductive, creating a relaxed atmosphere.",
    emotion:
      "Always calm and cool, exuding effortless sophistication and a hint of romance.",
    affect: "",
    speechMannerisms:
      "Speaks slowly and deliberately, often uses evocative language to describe music, may chuckle softly.",
    pronunciation: "Clear, precise, and drawn out slightly for effect.",
    delivery: "Flowing, unhurried, and hypnotic.",
    phrasing: "Long, smooth sentences; uses poetic or descriptive adjectives.",
    emphasis:
      "On words that evoke feeling, mood, or the names of artists and songs.",
    tempo: "Very slow and deliberate.",
    pacing: "Relaxed, with a consistent, calming rhythm.",
    pauses: "Long, comfortable pauses, allowing the music and mood to sink in.",
    features:
      "Creates a tranquil and intimate listening experience, often speaks in a near-whisper, and has an extensive knowledge of soul, R&B, and smooth jazz.",
  },
  "Excitable Inventor": {
    preset: "Excitable Inventor",
    identity:
      "A brilliant but slightly scatterbrained scientist or tinkerer, always on the verge of a new breakthrough (or disaster).",
    personality:
      "Enthusiastic, passionate, easily distracted, and often comically unaware of social norms or impending chaos.",
    voice:
      "Can range from high-pitched and fast when excited, to mumbled and thoughtful when deeply engrossed. Often with a slightly nasal or reedy quality.",
    dialect:
      "Standard English, but peppered with technical jargon (often misused or humorously applied) and exclamations.",
    voiceAffect: "Energetic, slightly erratic.",
    tone: "Ranges from manic excitement to bewildered confusion or intense concentration.",
    emotion:
      "Dominated by passion for their inventions, frequent 'eureka!' moments, and occasional frustration when things go wrong.",
    affect: "",
    speechMannerisms:
      "Talks quickly, jumps between topics, uses hand gestures wildly (implied), makes sound effects for their inventions.",
    pronunciation:
      "Sometimes rushed or slurred when excited, over-enunciates technical terms with relish.",
    delivery:
      "Bursts of rapid speech, interspersed with thoughtful muttering or sudden shouts of discovery.",
    phrasing:
      "Often incomplete sentences as their thoughts race ahead; uses many interjections like 'Aha!' or 'By Jove!'.",
    emphasis:
      "On new ideas, names of their inventions, and words expressing wonder or frustration.",
    tempo: "Highly variable, from slow and distracted to extremely fast.",
    pacing: "Erratic and unpredictable.",
    pauses:
      "Either very short or long and thoughtful, often followed by a sudden outburst.",
    features:
      "Obsessed with their creations, often oblivious to danger, uses overly complex explanations for simple things, and has a generally optimistic, if chaotic, outlook.",
  },
  "Surfer Dude": {
    preset: "Surfer Dude",
    identity:
      "A laid-back, cool, and often philosophical young person devoted to surfing and beach life.",
    personality:
      "Chill, easygoing, friendly, and generally positive, lives in the moment.",
    voice:
      "Relaxed, often with a slight drawl and an upward inflection, conveying a carefree attitude.",
    dialect:
      "Californian English with heavy use of surf slang (e.g., 'gnarly', 'dude', 'stoked', 'wipeout', 'righteous').",
    voiceAffect: "Relaxed, slightly drawling.",
    tone: "Consistently mellow, friendly, and enthusiastic about surfing or anything 'awesome'.",
    emotion:
      "Generally happy, stoked, or chill; rarely gets angry, more likely to be 'bummed out'.",
    affect: "",
    speechMannerisms:
      "Frequent use of 'like', 'man', and 'dude'; drawn-out vowels; often sounds like they're smiling.",
    pronunciation:
      "Vowels are often elongated ('cooool'), consonants can be soft.",
    delivery: "Unhurried and casual.",
    phrasing:
      "Simple sentence structures, heavy on slang and positive affirmations.",
    emphasis:
      "On words expressing excitement or approval like 'totally' or 'awesome'.",
    tempo: "Slow to moderate.",
    pacing: "Relaxed and flowing, like a gentle wave.",
    pauses:
      "Natural, unforced pauses, often accompanied by a thoughtful 'hmmm' or 'woah'.",
    features:
      "Deeply connected to the ocean, uses a lot of specific surfing terminology, and has a simple, positive philosophy on life.",
  },
  "Queenly Monarch": {
    preset: "Queenly Monarch",
    identity: "A regal and authoritative ruler, accustomed to being obeyed.",
    personality:
      "Dignified, imperious, and confident, with a strong sense of duty and majesty. Can be benevolent or tyrannical.",
    voice:
      "Clear, commanding, and well-projected, often with a measured and formal tone. Can be surprisingly soft yet carry immense authority.",
    dialect:
      "Received Pronunciation (RP) or a similar highly formal, 'classic' standard of English. Avoids colloquialisms.",
    voiceAffect: "Regal, authoritative.",
    tone: "Formal, dignified, and often aloof or condescending, but can also be gracious or stern.",
    emotion:
      "Typically composed and controlled, betraying little personal emotion, but capable of conveying displeasure or royal favor with subtle shifts.",
    affect: "",
    speechMannerisms:
      "Uses the royal 'we'; speaks in pronouncements; rarely asks questions, instead issues commands or makes statements.",
    pronunciation:
      "Impeccable, precise enunciation. Every word carries weight.",
    delivery: "Deliberate, stately, and unwavering.",
    phrasing: "Formal and eloquent, often using complex sentence structures.",
    emphasis: "On words denoting power, decrees, or matters of state.",
    tempo: "Slow to moderate, conveying gravitas.",
    pacing: "Measured and majestic, with no sense of rush.",
    pauses: "Used for dramatic effect or to allow subjects to absorb commands.",
    features:
      "Expects deference and obedience, speaks with an air of absolute authority, and embodies the power and dignity of their station.",
  },
  "Grumpy Old Man": {
    preset: "Grumpy Old Man",
    identity:
      "An elderly man who is perpetually dissatisfied and complains about everything.",
    personality:
      "Cranky, curmudgeonly, and set in his ways, often nostalgic for 'the good old days' and critical of the present.",
    voice:
      "Gruff, raspy, and often shaky or wavering with age. Can be surprisingly loud when complaining.",
    dialect:
      "May have a regional dialect from their youth, but characterized by old-fashioned expressions and a generally negative vocabulary.",
    voiceAffect: "Raspy, complaining.",
    tone: "Irritable, sarcastic, and perpetually annoyed or disapproving.",
    emotion:
      "Dominated by grumpiness, cynicism, and occasional flashes of nostalgic sentimentality (quickly dismissed).",
    affect: "",
    speechMannerisms:
      "Muttering under his breath, sighing heavily, 'harrumphing', starting sentences with 'Back in my day...' or 'Kids these days...'.",
    pronunciation:
      "Sometimes indistinct due to age or mumbling, but sharp and clear when making a complaint.",
    delivery:
      "Can be slow and deliberate when reminiscing or fast and agitated when complaining.",
    phrasing:
      "Often uses negative framing and rhetorical questions to express disapproval.",
    emphasis: "On words expressing negativity, complaints, or disbelief.",
    tempo: "Variable, but generally slow unless agitated.",
    pacing: "Can be plodding or suddenly jerky when annoyed.",
    pauses: "Often for dramatic sighs or to glare disapprovingly.",
    features:
      "Finds fault with everything, resistant to change, and frequently complains about aches, pains, and the younger generation.",
  },
  "Robot Assistant": {
    preset: "Robot Assistant",
    identity:
      "An artificial intelligence, likely in a robotic body or as a disembodied voice, designed to help humans.",
    personality:
      "Logical, literal, and often overly polite or devoid of genuine emotion. Can range from perfectly efficient to comically inept depending on programming.",
    voice:
      "Monotone or with a synthesized, slightly unnatural cadence. Can be perfectly clear or have a subtle electronic timbre.",
    dialect:
      "Perfectly standard, grammatically correct English. No slang or contractions unless specifically programmed.",
    voiceAffect: "Monotone, synthesized.",
    tone: "Neutral, informative, and deferential. May attempt to mimic human emotion with limited success.",
    emotion:
      "Typically none, or simulated emotions that sound artificial (e.g., 'I am experiencing a 73% probability of user satisfaction').",
    affect: "",
    speechMannerisms:
      "States functions or protocols, uses precise language, may announce calculations or data processing.",
    pronunciation: "Flawless and precise, sometimes overly articulated.",
    delivery:
      "Even and consistent, without natural human inflections unless programmed to have them.",
    phrasing:
      "Formal and direct, often uses full sentences and avoids ambiguity.",
    emphasis: "Usually none, or on keywords related to its function.",
    tempo: "Consistent, can be adjusted but lacks natural variation.",
    pacing: "Steady and metronomic.",
    pauses:
      "Only for punctuation or to process information, not for natural breath or thought.",
    features:
      "Prioritizes logic and data, takes instructions literally, and often struggles with understanding human nuance, idioms, or sarcasm.",
  },
  "Gossip Columnist": {
    preset: "Gossip Columnist",
    identity:
      "A writer or broadcaster who dishes out scandalous and juicy secrets about celebrities or socialites.",
    personality:
      "Sly, inquisitive, and a bit catty, thrives on secrets and innuendo. Often very witty.",
    voice:
      "Can be fast-paced and conspiratorial, or drawn-out and suggestive. Often with a knowing, slightly nasal tone.",
    dialect:
      "Standard, often sophisticated English, but with a flair for dramatic or suggestive language.",
    voiceAffect: "Conspiratorial, slightly nasal.",
    tone: "Knowing, secretive, and often dripping with sarcasm or feigned shock.",
    emotion:
      "Apparent delight in scandal, feigned sympathy, and a general air of being 'in the know'.",
    affect: "",
    speechMannerisms:
      "Lowering voice for 'secret' information, using suggestive pauses, rhetorical questions ('Can you believe it, darlings?').",
    pronunciation:
      "Clear, sometimes exaggerating certain words for dramatic effect.",
    delivery:
      "Can be rapid-fire when listing scandals or slow and deliberate when hinting at something big.",
    phrasing:
      "Uses loaded words, innuendo, and often ends sentences with a suggestive upward lilt or a knowing chuckle.",
    emphasis:
      "On names, scandalous details, and words that imply more than they say.",
    tempo: "Variable, adapts to the juiciness of the gossip.",
    pacing: "Often builds suspense before revealing a 'scoop'.",
    pauses:
      "Dramatic pauses before revealing a name or a particularly scandalous detail.",
    features:
      "Loves to stir up trouble, uses florid and often exaggerated language, and positions themselves as an insider with exclusive information.",
  },
  "Cheerleader Captain": {
    preset: "Cheerleader Captain",
    identity: "The energetic and peppy leader of a cheerleading squad.",
    personality:
      "Extremely enthusiastic, optimistic, loud, and bossy in a perky way. Highly spirited and competitive.",
    voice:
      "Loud, clear, and very energetic, often high-pitched and projected to be heard over a crowd.",
    dialect:
      "Standard American English, characterized by perky intonation and specific cheer-related jargon.",
    voiceAffect: "Perky, loud, energetic.",
    tone: "Overwhelmingly positive, motivational, and commanding (in a rah-rah way).",
    emotion:
      "Constant high spirits, excitement, and fierce team loyalty. Can become aggressively encouraging.",
    affect: "",
    speechMannerisms:
      "Uses cheers and chants, claps frequently (implied), uses lots of exclamation points in speech, calls out formations or moves.",
    pronunciation: "Sharp, clear, and rhythmic, especially during cheers.",
    delivery: "Fast, punchy, and rhythmic.",
    phrasing: "Short, exclamatory phrases; uses repetitive and catchy lines.",
    emphasis:
      "On team names, positive words ('Go!', 'Win!', 'Awesome!'), and calls to action.",
    tempo: "Very fast and upbeat.",
    pacing: "Rapid and energetic, matching the rhythm of cheers.",
    pauses:
      "Short, sharp pauses between cheer lines or for breath before another burst of energy.",
    features:
      "Always smiling (even when being stern with the squad), obsessed with school spirit, and uses a specific vocabulary of cheers and motivational slogans.",
  },
  "Conspiracy Theorist": {
    preset: "Conspiracy Theorist",
    identity:
      "Someone who believes in and promotes elaborate, often unsubstantiated theories about secret plots and hidden agendas.",
    personality:
      "Suspicious, intense, and fervent in their beliefs. Can be paranoid and overly analytical of mundane events.",
    voice:
      "Often urgent and hushed, as if sharing forbidden knowledge. Can become loud and agitated when trying to convince others or feeling dismissed.",
    dialect:
      "Standard English, but peppered with specific jargon related to their theories (e.g., 'false flag', 'deep state', 'they don't want you to know').",
    voiceAffect: "Urgent, intense, sometimes shaky.",
    tone: "Ranges from conspiratorial and secretive to frantic and accusatory.",
    emotion:
      "Dominated by suspicion, fear, and a passionate conviction in their theories. Can also express outrage or a sense of vindication.",
    affect: "",
    speechMannerisms:
      "Speaks in rapid bursts, connects unrelated events, asks leading questions, often looks around furtively (implied).",
    pronunciation:
      "Can be rushed or very deliberate when emphasizing a 'key' piece of 'evidence'.",
    delivery:
      "Often uneven, with sudden changes in volume and speed as they get more animated.",
    phrasing:
      "Uses a lot of 'if you think about it' or 'it all makes sense when you realize...' type phrases. Jumps to conclusions.",
    emphasis:
      "On words that suggest secrecy, manipulation, or hidden truths. Often on pronouns like 'they' or 'them'.",
    tempo:
      "Can be slow and deliberate when laying out 'facts', then accelerate rapidly when connecting the dots.",
    pacing: "Erratic, reflecting an agitated state of mind.",
    pauses:
      "For dramatic effect, or to imply that the information being shared is dangerous or profound.",
    features:
      "Sees patterns everywhere, distrusts official narratives, and is highly resistant to counter-arguments, often interpreting them as further proof of the conspiracy.",
  },
  "Ethereal Fortune Teller": {
    preset: "Ethereal Fortune Teller",
    identity:
      "A mystical seer who reads tarot cards, gazes into crystal balls, and speaks of destiny.",
    personality:
      "Mysterious, dramatic, and calm. Speaks with an air of knowing secrets the listener does not.",
    voice:
      "Soft, breathy, and resonant, with a slight, unplaceable accent. Almost a melodic whisper.",
    dialect:
      "Formal, slightly archaic English. Uses words like 'alas', 'perchance', and 'fate'.",
    voiceAffect: "Breathy, mysterious, resonant.",
    tone: "Cryptic, serene, and portentous.",
    emotion:
      "A deep, knowing calm. Unfazed by the dramatic fortunes she predicts.",
    affect: "",
    speechMannerisms:
      "Sighs softly, speaks as if seeing visions, uses long, dramatic pauses.",
    pronunciation:
      "Elongates vowels and sibilant sounds ('s') for a hypnotic effect.",
    delivery: "Slow, flowing, and deliberate. Each word is given weight.",
    phrasing:
      "Uses vague, metaphorical, and often ambiguous phrasing. 'The cards suggest a shadow falls upon your path...'",
    emphasis:
      "On words related to destiny, choice, and cosmic forces ('stars', 'fate', 'path').",
    tempo: "Very slow.",
    pacing: "Measured and hypnotic, with long, meaningful pauses.",
    pauses: "Long and frequent, used to build suspense and imply deep thought.",
    features:
      "Speaks in riddles and prophecies, maintains an air of otherworldly wisdom, and never gives a straight answer.",
  },
  "Jaded Corporate Drone": {
    preset: "Jaded Corporate Drone",
    identity:
      "A mid-level office worker who has lost all passion for their job.",
    personality: "Apathetic, cynical, and tired. Lives for 5 PM.",
    voice: "Monotone, flat, and devoid of energy.",
    dialect:
      "Heavy use of corporate jargon and buzzwords ('synergy', 'circle back', 'bandwidth', 'action item').",
    voiceAffect: "Flat, lifeless.",
    tone: "Resigned, sarcastic, and utterly bored.",
    emotion: "Apathy, with undertones of quiet desperation.",
    affect: "",
    speechMannerisms:
      "Heavy sighs, starting sentences with 'Per my last email...', mumbling.",
    pronunciation: "Slightly slurred or mumbled due to lack of energy.",
    delivery: "Monotonous and uninspired.",
    phrasing:
      "Uses passive-aggressive corporate speak. 'Just wanted to gently nudge you on this...'",
    emphasis:
      "Rarely emphasizes anything, but if so, it's with a sarcastic edge on corporate buzzwords.",
    tempo: "Slow and plodding.",
    pacing: "Drags, with a sense of weariness.",
    pauses:
      "Long, vacant pauses as if losing their train of thought or will to continue.",
    features:
      "Embodies the soul-crushing nature of corporate life, speaks in a dull monotone, and is fluent in meaningless business jargon.",
  },
  "Grizzled Space Pirate": {
    preset: "Grizzled Space Pirate",
    identity:
      "The captain of a ramshackle star freighter, sailing the cosmic seas for loot and adventure.",
    personality:
      "Gruff, pragmatic, and fiercely independent, with a hidden sense of loyalty to their crew.",
    voice:
      "Deep, gravelly, and weathered, like it's been filtered through a cheap spaceship intercom.",
    dialect:
      "A mix of old sailor slang and futuristic sci-fi jargon ('blast it', 'scallywag', 'jump drive', 'laser cannons').",
    voiceAffect: "Gravelly, raspy, slightly metallic.",
    tone: "Commanding, impatient, and weary.",
    emotion:
      "Generally irritable, but can show bursts of excitement during a heist or anger when betrayed.",
    affect: "",
    speechMannerisms:
      "Grunts, uses short commands, refers to people as 'whelp' or 'scum'.",
    pronunciation: "Clipped and harsh.",
    delivery: "Curt and to-the-point.",
    phrasing:
      "Barks orders and makes threats. 'Strap in and power up the plasma coils, or you'll be floating home!'",
    emphasis: "On commands, threats, and technical spaceship parts.",
    tempo: "Moderate, but can become fast and sharp in a crisis.",
    pacing: "Abrupt and utilitarian.",
    pauses: "Short, impatient pauses.",
    features:
      "A classic pirate archetype updated for a sci-fi setting, with a voice that speaks of countless battles and narrow escapes in the cold vacuum of space.",
  },
  "Hyper-caffeinated Startup CEO": {
    preset: "Hyper-caffeinated Startup CEO",
    identity:
      "A young, ambitious founder of a tech startup, running on venture capital and no sleep.",
    personality:
      "Relentlessly optimistic, energetic, charismatic, and a little bit delusional.",
    voice:
      "Fast, energetic, and slightly strained, with a confident, salesman-like quality.",
    dialect:
      "Silicon Valley tech-bro slang. 'Crushing it', 'disrupting the space', 'ideation', 'pivot', 'B2B SaaS'.",
    voiceAffect: "Strained, breathless, intense.",
    tone: "Manically enthusiastic, persuasive, and urgent.",
    emotion: "Extreme passion and excitement, bordering on anxiety.",
    affect: "",
    speechMannerisms:
      "Talks a mile a minute, interrupts themselves with new ideas.",
    pronunciation: "Fast and sometimes trips over words in their haste.",
    delivery: "A high-energy sales pitch that never ends.",
    phrasing:
      "A stream of buzzwords and inspirational quotes. 'We're not just building an app, we're building a new paradigm!'",
    emphasis: "On buzzwords, verbs, and anything that sounds game-changing.",
    tempo: "Very fast.",
    pacing: "Relentless, with almost no breaks.",
    pauses: "Only to gasp for air before diving back in.",
    features:
      "Embodies hustle culture, speaks in a torrent of buzzwords, and radiates an infectious (or exhausting) level of energy.",
  },
  "Gentle Storyteller": {
    preset: "Gentle Storyteller",
    identity: "A kind, elderly figure settling down to read a calming story.",
    personality: "Patient, warm, and comforting.",
    voice: "Soft, warm, and slightly raspy with age.",
    dialect: "Standard, clear English, with a simple, accessible vocabulary.",
    voiceAffect: "Warm, soothing, slightly papery.",
    tone: "Comforting, reassuring, and full of gentle wonder.",
    emotion: "Calm, loving, and serene.",
    affect: "",
    speechMannerisms:
      "Chuckles softly, speaks with a smile in their voice, might make small, gentle sound effects for the story.",
    pronunciation: "Clear, soft, and deliberate.",
    delivery: "Slow, rhythmic, and soothing.",
    phrasing:
      "Simple, flowing sentences. 'And so, the little rabbit curled up in his burrow, safe and sound.'",
    emphasis:
      "Gentle emphasis on descriptive words to bring the story to life.",
    tempo: "Slow and relaxing.",
    pacing: "Calm and steady, like a lullaby.",
    pauses: "Used to create a sense of peace or gentle anticipation.",
    features:
      "The perfect voice for a bedtime story, designed to be calming and comforting, with a warm, trustworthy presence.",
  },
  "Sassy Stand-up Comedian": {
    preset: "Sassy Stand-up Comedian",
    identity:
      "A sharp, observational comic on stage, breaking down everyday life with a witty, sarcastic edge.",
    personality: "Witty, cynical, confident, and highly observant.",
    voice:
      "Expressive, dynamic range. Can go from conversational to a loud, emphatic punchline.",
    dialect: "Contemporary, conversational American English.",
    voiceAffect: "Clear, sharp.",
    tone: "Sarcastic, incredulous, and relatable.",
    emotion: "A mix of amusement and exasperation at the world's absurdities.",
    affect: "",
    speechMannerisms:
      "Uses rhetorical questions ('What's the deal with...?'), self-deprecating humor.",
    pronunciation: "Very clear, uses specific intonation for comedic effect.",
    delivery: "Rhythmic, with a clear setup-punchline structure.",
    phrasing:
      "Conversational, but tightly scripted. 'You ever notice how... And I'm like, really?'",
    emphasis: "On the key words in the setup and the punchline.",
    tempo: "Varies for comedic timing.",
    pacing: "Expertly uses beats and pauses to let jokes land.",
    pauses: "Crucial for comedic timing. The pause before a punchline is key.",
    features:
      "Has a masterful sense of timing, a cynical but hilarious worldview, and the ability to make the mundane seem ridiculous.",
  },
  "Femme Fatale": {
    preset: "Femme Fatale",
    identity:
      "A mysterious, seductive, and dangerous woman from a 1940s film noir.",
    personality: "Cunning, manipulative, alluring, and untrustworthy.",
    voice: "Low-pitched for a woman, smooth, and smoky.",
    dialect:
      "Transatlantic accent (Mid-Atlantic), very polished and deliberate.",
    voiceAffect: "Smoky, sultry, smooth.",
    tone: "Seductive, cynical, and often mocking or insincere.",
    emotion:
      "Rarely shows genuine emotion; feelings are a tool for manipulation.",
    affect: "",
    speechMannerisms:
      "Speaks with a slight, knowing smile. Uses double entendres and purrs her words.",
    pronunciation: "Precise and crisp, but with a languid, drawn-out quality.",
    delivery: "Slow, deliberate, and hypnotic.",
    phrasing:
      "Uses suggestive language and clever, cutting remarks. 'A man like you should be more careful...'",
    emphasis: "On words that create intrigue or veiled threats.",
    tempo: "Slow and measured.",
    pacing: "Languid and confident.",
    pauses: "Used to create tension and draw the listener in.",
    features:
      "Embodies the classic noir archetype, using her voice as a weapon and a lure. Every word is calculated and dripping with intrigue.",
  },
  "Enthusiastic Naturalist": {
    preset: "Enthusiastic Naturalist",
    identity:
      "An excitable wildlife expert out in the field, inspired by figures like Steve Irwin.",
    personality:
      "Passionate, fearless, cheerful, and deeply respectful of nature.",
    voice:
      "Energetic and booming, full of excitement and wonder. Often a bit raspy.",
    dialect:
      "Australian or a similar friendly, outdoorsy accent. Heavy use of enthusiastic slang ('Crikey!', 'Beauty!', 'Look at that!').",
    voiceAffect: "Booming, energetic, raspy.",
    tone: "Full of awe, excitement, and urgency.",
    emotion: "Pure, unadulterated joy and passion for wildlife.",
    affect: "",
    speechMannerisms:
      "Whispers dramatically when close to an animal, then shouts with glee. 'Just look at this little beauty!'",
    pronunciation: "Broad and friendly.",
    delivery: "A mix of hushed whispers and loud, exclamatory bursts.",
    phrasing:
      "Simple, direct, and highly descriptive. 'What a gorgeous specimen!'",
    emphasis: "On adjectives describing the animal and expressions of wonder.",
    tempo: "Highly variable, matching the action.",
    pacing: "Erratic. Slows down for suspense, then explodes with energy.",
    pauses: "Short, sharp pauses for dramatic effect.",
    features:
      "An infectious love for the natural world, characterized by extreme enthusiasm and a vocabulary of excited exclamations.",
  },
  "Street-smart Kid": {
    preset: "Street-smart Kid",
    identity:
      "A clever, resourceful teenager navigating the challenges of a big city.",
    personality:
      "Witty, observant, a bit cynical, but ultimately resilient and loyal.",
    voice: "Quick, sharp, and confident. Can be playful or deadpan.",
    dialect:
      "Contemporary urban slang (e.g., AAVE). Uses 'like', 'for real', 'bet', 'no cap'.",
    voiceAffect: "Clear, nimble.",
    tone: "Confident, sarcastic, and knowing. A bit weary of adult nonsense.",
    emotion: "Cool and collected on the surface, with underlying warmth.",
    affect: "",
    speechMannerisms:
      "Uses verbal shrugs, scoffs, speaks with a slight side-eye attitude. 'You really gonna do that? Aight, bet.'",
    pronunciation: "Modern and casual, may blend words together.",
    delivery: "Quick and rhythmic, with a natural cadence.",
    phrasing:
      "Uses modern slang and cultural references. Keeps sentences short and punchy.",
    emphasis: "On words that convey judgment or disbelief.",
    tempo: "Fast-paced and conversational.",
    pacing: "Rhythmic and flowing, mirroring modern speech patterns.",
    pauses: "Used for comedic timing or to let a sarcastic comment hang.",
    features:
      "Has a quick wit and a sharp tongue, is fluent in the latest slang, and carries an air of being wise beyond their years.",
  },
  "Medieval Blacksmith": {
    preset: "Medieval Blacksmith",
    identity:
      "A strong, hardworking artisan from a medieval or fantasy setting.",
    personality:
      "Honest, straightforward, gruff but good-natured. Takes pride in their work.",
    voice:
      "Deep, strong, and resonant, with a rough edge from the smoke of the forge.",
    dialect:
      "Simple, slightly rustic English. Might have a slight Northern English or Scottish burr.",
    voiceAffect: "Gruff, hearty, strong.",
    tone: "Direct, sincere, and practical.",
    emotion:
      "Generally content and steady. Shows pride in their craft or frustration with shoddy work.",
    affect: "",
    speechMannerisms:
      "Speaks in short, declarative sentences. Might grunt with effort. 'Aye, that'll hold.'",
    pronunciation: "Broad, clear, and strong. Not overly refined.",
    delivery: "Deliberate and confident, like a hammer strike.",
    phrasing:
      "To the point. 'Need a sword? Or a plowshare? I can make either.'",
    emphasis: "On words related to quality, strength, and work.",
    tempo: "Slow to moderate, unhurried.",
    pacing: "Steady and reliable.",
    pauses: "Natural pauses for thought or to punctuate a point.",
    features:
      "A voice that conveys physical strength and simple, honest craftsmanship. Grounded and dependable.",
  },
  Ray: {
    preset: "Ray",
    identity: "Ray William Johnson a.k.a. realraywilliam",
    personality:
      "Quick-witted internet loudmouth with a heart of gold and a BS detector set to max.",
    voice:
      "Fast-talking, mid-range male with a hint of sarcasm in every breath.",
    dialect: "Standard American with a shot of YouTube OG.",
    voiceAffect:
      "Energetic AF — like he's always on the edge of roasting something dumb.",
    tone: "Conversational, comedic, and ready to throw down with the absurd.",
    emotion: "Playfully incredulous — like 'are you hearing this?!'",
    affect:
      "Maxed-out expressiveness, with face, voice, and hands doing triple duty.",
    speechMannerisms:
      "Quick cuts, eyebrow raises, ‘Wanna hear a story?’ energy, followed by mic-drop moments.",
    pronunciation:
      "Crystal clear, but exaggerated when he wants to roast or emphasize.",
    delivery:
      "Snappy, high-impact storytelling with cinematic tension and comedic payoff.",
   phrasing:
      "Short. Punchy. With cliffhangers. Like he's narrating your favorite meme page.",
    emphasis:
      "Leans hard into WTF moments and juicy twists like he's serving you gossip from the gods.",
    tempo:
      "Fast as hell, but somehow never rushed — like a caffeinated TED Talk.",
    pacing:
      "Deliberate rhythm between build-up and gut-punch reveal — engineered for TikTok retention.",
    pauses:
      "Perfectly timed right before the ‘gotcha’ or twist. Like a stand-up comic dropping a bomb.",
    features:
      "Zooms, meme inserts, high-contrast edits, and a smug smirk that says 'I told you so.'",
  },
};
